import * as Styles from './SectionCard.styles';

export type SectionCardProps = {
  /** Section title displayed in the header. */
  title: string;
  /** Optional subtitle displayed below the title. */
  subtitle?: string;
  /** Optional icon rendered before the title. */
  icon?: React.ReactNode;
  /** Optional action element rendered on the right side of the header (e.g. a refresh button). */
  action?: React.ReactNode;
  /** Optional badge rendered next to the title (e.g. a count chip). */
  badge?: React.ReactNode;
  /** The section body content. */
  children: React.ReactNode;
  /** Apply a thicker, tinted border to emphasize this section. */
  highlighted?: boolean;
};

const SectionCard = function ({
  title,
  subtitle,
  icon,
  action,
  badge,
  children,
  highlighted = false,
}: SectionCardProps): JSX.Element {
  return (
    <Styles.Card $highlighted={highlighted}>
      <Styles.Header $hasSubtitle={!!subtitle}>
        {icon}
        <Styles.Title>{title}</Styles.Title>
        {badge}
        {action && <Styles.ActionWrapper>{action}</Styles.ActionWrapper>}
      </Styles.Header>

      {subtitle && <Styles.Subtitle>{subtitle}</Styles.Subtitle>}

      {children}
    </Styles.Card>
  );
};

export default SectionCard;
